import React from "react";
import { makeStyles } from "tss-react/mui";
import { IAttemptListItemResponseForWorkOrder, IHome } from "@miplatform/types";
import {
  AddressDetailFields,
  WorkOrderDetailFields,
} from "@mibuildweb/components";
import { Box } from "@mui/material";

export const WorkOrderDrawerDetailsTab = ({
  attempt,
  home,
}: WorkOrderDrawerDetailsTabProps): React.ReactNode => {
  const { classes } = useStyles();
  return (
    <Box className={classes.container}>
      {home && <AddressDetailFields home={home} />}
      {attempt.assignment?.workOrder && (
        <WorkOrderDetailFields workOrder={attempt.assignment.workOrder} />
      )}
    </Box>
  );
};

interface WorkOrderDrawerDetailsTabProps {
  attempt: IAttemptListItemResponseForWorkOrder;
  home: IHome | null;
}

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));
